module.exports = __webpack_public_path__ + "img/audacity-fund.9ee52cf6.png";